// extracted by mini-css-extract-plugin
export default {"modalTitle":"modal_modalTitle__VqbqO","modalBody":"modal_modalBody__w0es+"};